import { statusCodes } from "./status-codes.js";

export const ENTITY_NOT_FOUND = "Entity not found";
export const SHARED_ENTITY_NOT_FOUND = "Shared entity not found";
export const INVALID_CREDENTIALS = "Invalid credentials";
export const INVALID_ARGUMENT = "Invalid Argument";
export const BAD_REQUEST = "Bad request";
export const UNAUTHORIZED = "Unauthorized";
export const NON_UNIQUE_ENTITY = "Entity already exists";
export const MISSING_REQUIRED_FIELDS = "Missing required fields";
export const INVALID_PASSWORD =
  "Password must contain at least 8 characters, including at least 1 uppercase and lowercase letter, and at least 1 digit or special character";
export const OAUTH_PROVIDER_FOUND =
  "Third party authorization provider found, password reset is not allowed";
export const UNEXPECTED_ERROR = "Unexpected error";
export const COUPON_NOT_FOUND = "Coupon not found";
export const PROMOTION_EXPIRED = "Promotion expired";
export const PROMOTION_NOT_STARTED = "Promotion not started yet";
export const INVALID_TIMEZONE = "Invalid timezone";

//Credits
export const NOT_ENOUGH_CREDITS = "Not enough credits available";
export const AUTO_RELOAD_CONFIGURED =
  "Auto-reload is already configured for this workspace";
export const AUTO_RELOAD_NOT_CONFIGURED =
  "Auto-reload is not configured for this workspace";
export const RELOAD_THRESHOLD_EXCEEDED =
  "Current credits exceed the auto-reload threshold";
export const AUTO_RELOAD_FAILED = "Auto-reload payment failed";

//Invites
export const INVITE_EMAIL_MISMATCH =
  "This invitation was sent to a different email address";
export const INVITE_EXPIRED =
  "This invitation has expired. Please request a new one";
export const INVITE_ALREADY_ACCEPTED =
  "This invitation has already been accepted";
export const INVITE_RATE_LIMITED =
  "Cannot send another invitation to this email within 24 hours";
export const USER_ALREADY_IN_WORKSPACE =
  "User is already a member of the workspace";
export const INVITE_COULD_NOT_BE_PROCESSED =
  "The invitation could not be processed";

export const ERRORS = {
  [ENTITY_NOT_FOUND]: {
    code: "EntityNotFound",
    message: ENTITY_NOT_FOUND,
    status: statusCodes.NOT_FOUND,
  },
  [SHARED_ENTITY_NOT_FOUND]: {
    code: "SharedEntityNotFound",
    message: SHARED_ENTITY_NOT_FOUND,
    status: statusCodes.NOT_FOUND,
  },
  [UNAUTHORIZED]: {
    code: "Unauthorized",
    message: UNAUTHORIZED,
    status: statusCodes.UNAUTHORIZED,
  },
  [INVALID_ARGUMENT]: {
    code: "InvalidArgument",
    message: INVALID_ARGUMENT,
    status: statusCodes.BAD_REQUEST,
  },
  [INVALID_CREDENTIALS]: {
    code: "InvalidCredentials",
    message: INVALID_CREDENTIALS,
    status: statusCodes.FORBIDDEN,
  },
  [NON_UNIQUE_ENTITY]: {
    code: "NonUniqueEntity",
    message: NON_UNIQUE_ENTITY,
    status: statusCodes.BAD_REQUEST,
  },
  [MISSING_REQUIRED_FIELDS]: {
    code: "MissingRequiredFields",
    message: MISSING_REQUIRED_FIELDS,
    status: statusCodes.BAD_REQUEST,
  },
  [INVALID_PASSWORD]: {
    code: "InvalidPassword",
    message: INVALID_PASSWORD,
    status: statusCodes.UNAUTHORIZED,
  },
  [OAUTH_PROVIDER_FOUND]: {
    code: "OauthProviderFound",
    message: OAUTH_PROVIDER_FOUND,
    status: statusCodes.BAD_REQUEST,
  },
  [UNEXPECTED_ERROR]: {
    code: "UnexpectedError",
    message: UNEXPECTED_ERROR,
    status: statusCodes.INTERNAL_SERVER_ERROR,
  },
  [BAD_REQUEST]: {
    code: "BadRequest",
    message: BAD_REQUEST,
    status: statusCodes.BAD_REQUEST,
  },
  [PROMOTION_EXPIRED]: {
    code: "PromotionExpired",
    message: PROMOTION_EXPIRED,
    status: statusCodes.BAD_REQUEST,
  },
  [PROMOTION_NOT_STARTED]: {
    code: "PromotionNotStarted",
    message: PROMOTION_NOT_STARTED,
    status: statusCodes.BAD_REQUEST,
  },
  [INVALID_TIMEZONE]: {
    code: "InvalidTimezone",
    message: INVALID_TIMEZONE,
    status: statusCodes.BAD_REQUEST,
  },
  [COUPON_NOT_FOUND]: {
    code: "CouponNotFound",
    message: COUPON_NOT_FOUND,
    status: statusCodes.INTERNAL_SERVER_ERROR,
  },
  [NOT_ENOUGH_CREDITS]: {
    code: "NotEnoughCredits",
    message: NOT_ENOUGH_CREDITS,
    status: statusCodes.BAD_REQUEST,
  },
  [AUTO_RELOAD_CONFIGURED]: {
    code: "AutoReloadConfigured",
    message: AUTO_RELOAD_CONFIGURED,
    status: statusCodes.BAD_REQUEST,
  },
  [AUTO_RELOAD_NOT_CONFIGURED]: {
    code: "AutoReloadNotConfigured",
    message: AUTO_RELOAD_NOT_CONFIGURED,
    status: statusCodes.BAD_REQUEST,
  },
  [RELOAD_THRESHOLD_EXCEEDED]: {
    code: "ReloadThresholdExceeded",
    message: RELOAD_THRESHOLD_EXCEEDED,
    status: statusCodes.BAD_REQUEST,
  },
  [AUTO_RELOAD_FAILED]: {
    code: "AutoReloadFailed",
    message: AUTO_RELOAD_FAILED,
    status: statusCodes.PAYMENT_REQUIRED,
  },
  [INVITE_EMAIL_MISMATCH]: {
    code: "InviteEmailMismatch",
    message: INVITE_EMAIL_MISMATCH,
    status: statusCodes.FORBIDDEN,
  },
  [INVITE_EXPIRED]: {
    code: "InviteExpired",
    message: INVITE_EXPIRED,
    status: statusCodes.BAD_REQUEST,
  },
  [INVITE_RATE_LIMITED]: {
    code: "InviteRateLimited",
    message: INVITE_RATE_LIMITED,
    status: statusCodes.TOO_MANY_REQUESTS,
  },
  [USER_ALREADY_IN_WORKSPACE]: {
    code: "UserAlreadyInWorkspace",
    message: USER_ALREADY_IN_WORKSPACE,
    status: statusCodes.BAD_REQUEST,
  },
  [INVITE_COULD_NOT_BE_PROCESSED]: {
    code: "InviteCouldNotBeProcessed",
    message: INVITE_COULD_NOT_BE_PROCESSED,
    status: statusCodes.INTERNAL_SERVER_ERROR,
  },
  [INVITE_ALREADY_ACCEPTED]: {
    code: "InviteAlreadyAccepted",
    message: INVITE_ALREADY_ACCEPTED,
    status: statusCodes.BAD_REQUEST,
  },
};
